class Global{
    constructor(){
        
    }
    static emailjsId = "user_SsazCpFD70PMO2FuhPDOK";
    static recaptchaSiteKey = "6LeY_coUAAAAAFhUbquDuvyhMx3l2uiaIH6wmm66";

    static getEmailJsId(){
        return this.emailjsId;
    }
    static getRecaptchaSiteKey(){
        return this.recaptchaSiteKey;
    }
    
}
export default Global;


// WEBPACK FOOTER //
// ./src/Global.js